<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Activity Log</h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">User</th>
          <th class="px-6 pt-6 pb-4">Action</th>
          <th class="px-6 pt-6 pb-4">Subject Type</th>
          <th class="px-6 pt-6 pb-4">Subject ID</th>
          <th class="px-6 pt-6 pb-4">Subject Name</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Timestamp</th>
        </tr>
        <tr v-for="activity in activities.data" :key="activity.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('activity.show', activity.id)">
              {{ activity.causer }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('activity.show', activity.id)" tabindex="-1">
              {{ activity.description }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('activity.show', activity.id)" tabindex="-1">
              {{ activity.subject_type }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('activity.show', activity.id)" tabindex="-1">
              {{ activity.subject_id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('activity.show', activity.id)" tabindex="-1">
              {{ activity.subject_name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('activity.show', activity.id)" tabindex="-1">
              {{ dateFormat(activity.timestamp) }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('activity.show', activity.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="activities.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No log entries found.</td>
        </tr>
      </table>
    </div>
    <pagination class="my-6" :links="activities.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import { DateTime } from "luxon";

export default {
  metaInfo: { title: 'Activity Log' },
  components: {
    Icon,
    Pagination
  },
  layout: Layout,
  props: {
    activities: Object,
  },
  methods: {
    dateFormat(iso) {
      return DateTime.fromISO(iso).toFormat('dd LLL yyyy HH:mm ZZZZ')
    },
  },
}
</script>
